import { api } from "./api";
import { MedicationForm } from "../types";

export const dosagesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDosages: builder.query<
      { amount: number; unit: string }[],
      { productId: number; params?: { form?: MedicationForm } }
    >({
      query: ({ productId, params }) => ({
        url: `/api/dosages/${productId}`,
        method: "GET",
        params,
      }),
    }),
  }),
});

export const { useGetDosagesQuery } = dosagesApi;
